import React, {useState, useEffect} from "../../../__snowpack__/pkg/react.js";
import {useGetTipsListModal as useGetTipsList} from "../../entities/useGetTips.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import GnAlert from "../GnAlert/index.js";
const PromptMessage = (props) => {
  const {pageName, setMessageStatus, style, diyMessage = ""} = props;
  const [alertStatus, setAlertStatus] = useState(false);
  const {tipInfo, tipsListLoading, fetchTipsList} = useGetTipsList();
  const [tipMessage, setTipMessage] = useState("");
  const setMsgStatus = () => {
    setAlertStatus(true);
    setMessageStatus && setMessageStatus("end");
  };
  const resetMsgStatus = () => {
    setAlertStatus(false);
    setMessageStatus && setMessageStatus("start");
  };
  const setAlertClose = (status) => {
    resetMsgStatus();
  };
  const setMessageLanguage = () => {
    let language = localStorage.getItem("language");
    if (language && tipsListLoading === false) {
      switch (language) {
        case "en":
          if (tipInfo["descEn"]) {
            setMsgStatus();
            setTipMessage(tipInfo["descEn"]);
          } else {
            setMessageStatus && setMessageStatus("empty");
          }
          break;
        case "zh":
          if (tipInfo["descZh"]) {
            setMsgStatus();
            setTipMessage(tipInfo["descZh"]);
          } else {
            setMessageStatus && setMessageStatus("empty");
          }
          break;
        case "id":
          if (tipInfo["descIn"]) {
            setMsgStatus();
            setTipMessage(tipInfo["descIn"]);
          } else {
            setMessageStatus && setMessageStatus("empty");
          }
          break;
        case "vn":
          if (tipInfo["descVn"]) {
            setMsgStatus();
            setTipMessage(tipInfo["descVn"]);
          } else {
            setMessageStatus && setMessageStatus("empty");
          }
          break;
        case "th":
          if (tipInfo["descTh"]) {
            setMsgStatus();
            setTipMessage(tipInfo["descTh"]);
          } else {
            setMessageStatus && setMessageStatus("empty");
          }
          break;
        default:
          setMessageStatus && setMessageStatus("empty");
      }
    }
  };
  const handleUrlReg = (val) => {
    if (!val)
      return "";
    const regTextAndUrl = /\[.*?\}\]/g;
    const resVal = val.replace(regTextAndUrl, (matchVal) => {
      const textAndUrl = matchVal.split(/\[|\{|\}\]/g);
      const text = textAndUrl[1];
      const url = textAndUrl[2];
      if (text.length === 0 || url.length === 0)
        return matchVal;
      return `<a href="${url}" target="_blank">${text}</a>`;
    });
    return resVal.replace(/\n/g, "<br>");
  };
  const getVnode = (val) => {
    return /* @__PURE__ */ React.createElement("div", {
      dangerouslySetInnerHTML: {__html: handleUrlReg(val)}
    });
  };
  useEffect(() => {
    resetMsgStatus();
    if (pageName) {
      let param = {
        pageNames: [pageName]
      };
      fetchTipsList(param);
    }
  }, [pageName]);
  useEffect(() => {
    resetMsgStatus();
    if (!tipsListLoading) {
      setMessageLanguage();
    }
  }, [tipsListLoading]);
  return /* @__PURE__ */ React.createElement(Wrapper, null, alertStatus && tipMessage && /* @__PURE__ */ React.createElement("div", {
    className: "alert-wrapper",
    style
  }, /* @__PURE__ */ React.createElement(GnAlert, {
    style: {
      wordWrap: "break-word",
      wordBreak: "break-all",
      whiteSpace: "pre-wrap",
      ...style
    },
    type: "warning",
    showIcon: true,
    closable: true,
    onClose: () => setAlertClose(false),
    message: diyMessage ? /* @__PURE__ */ React.createElement("p", null, diyMessage) : getVnode(tipMessage)
  })));
};
const Wrapper = styled.div`
  .ant-alert-content {
    margin-right: 10px;
  }
`;
export default PromptMessage;
